import axios from './axios';

export const loadInvoice = (invoiceId: string) => axios.get(`/billing/invoice/${invoiceId}`);

export const loadCustomerInvoices = (customerId: string) => axios.get(`/billing/customer/invoices/${customerId}`);

export const loadCustomer = (customerId: string) => axios.get(`/billing/customer/${customerId}`);
